import { render, staticRenderFns } from "./organizations.vue?vue&type=template&id=2bd1a062&scoped=true"
import script from "./organizations.vue?vue&type=script&lang=js"
export * from "./organizations.vue?vue&type=script&lang=js"
import style0 from "./organizations.vue?vue&type=style&index=0&id=2bd1a062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd1a062",
  null
  
)

export default component.exports